import React, { useState, useEffect, useContext, Component } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import toast from "react-hot-toast";
import { Helmet } from 'react-helmet';
import Header from '../components/Header'
import Footer from '../components/Footer';
import axiosInstance, { Homeurl } from '../../axiosInstance';
import LoadingScreen from '../components/LoadingScreen';
import { QRCodeSVG } from 'qrcode.react';
// utils/useDate.js


const CardView = () => {


  const [loading, setloading] = useState(true);

  const [Page, setPage] = useState({});
  const [User, setUser] = useState([]);
  const [myDate, setDate] = useState('');

  const { id } = useParams();
 
  useEffect(() => {
    if (id) {
      // Construct the URL and redirect to it
      const redirectUrl = `${Homeurl}server/card.php?id=${id}`;
      window.location.replace(redirectUrl);  // Redirects the user to the new URL
    }
  }, [id]);


  return (
    <>
      <Header />

      <main className="page whitesmoke">
        {/* Header */}
        {/* Header */}


        {/* Blog Title */}
        {/* Blog List */}
        <div className="container ">
          <div className="row g-10 pb-5 pt-5">
            {/* Blog List */}
               {/* Article */}
                <LoadingScreen />
            
            {/* Blog List */}

          </div>
        </div>
        {/* Blog List*/}
      </main >




      <Footer />
    </>

  )
}

export default CardView